/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface CsvPatchAssertErrorResponse
 */
export interface CsvPatchAssertErrorResponse {
  /**
   * A display string for the error
   * @type {string}
   * @memberof CsvPatchAssertErrorResponse
   */
  error: string;
  /**
   * HTTP status code in the body
   * @type {number}
   * @memberof CsvPatchAssertErrorResponse
   */
  status?: number;
  /**
   * enum error type string to make a condition on
   * @type {string}
   * @memberof CsvPatchAssertErrorResponse
   */
  type: CsvPatchAssertErrorResponseTypeEnum;
}

/**
 * @export
 */
export const CsvPatchAssertErrorResponseTypeEnum = {
  LeadMappingRequired: 'lead_mapping_required',
  LeadMappingKeysMissing: 'lead_mapping_keys_missing',
  InvalidState: 'invalid_state',
} as const;
export type CsvPatchAssertErrorResponseTypeEnum =
  (typeof CsvPatchAssertErrorResponseTypeEnum)[keyof typeof CsvPatchAssertErrorResponseTypeEnum];

/**
 * Check if a given object implements the CsvPatchAssertErrorResponse interface.
 */
export function instanceOfCsvPatchAssertErrorResponse(
  value: object,
): value is CsvPatchAssertErrorResponse {
  if (!('error' in value) || value['error'] === undefined) return false;
  if (!('type' in value) || value['type'] === undefined) return false;
  return true;
}

export function CsvPatchAssertErrorResponseFromJSON(
  json: any,
): CsvPatchAssertErrorResponse {
  return CsvPatchAssertErrorResponseFromJSONTyped(json, false);
}

export function CsvPatchAssertErrorResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CsvPatchAssertErrorResponse {
  if (json == null) {
    return json;
  }
  return {
    error: json['error'],
    status: json['status'] == null ? undefined : json['status'],
    type: json['type'],
  };
}

export function CsvPatchAssertErrorResponseToJSON(
  value?: CsvPatchAssertErrorResponse | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    error: value['error'],
    status: value['status'],
    type: value['type'],
  };
}
